import { useDispatch, useSelector } from 'react-redux';
import AiqBackdrop from '../Loaders/Backdrop';
import { Button, Stack, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkSlash } from '@fortawesome/pro-solid-svg-icons';
import { generalActions } from 'store/generalSlice/generalSlice';
import { transactionActions } from 'store/transactionsSlice/transactionsSlice';
import { selectIsSharedWorkerDead } from 'store/generalSlice/generalSelectors';
import { sendLocalStorageSignal } from 'utils/sessionStorageHandlers';
import { SHARED_WORKER_DEAD_SIGNAL, flushLogsThenReload } from 'services/SharedWorkerLiveness/sharedWorkerLiveness';

function DisconnectedFromSharedWorker() {
    const dispatch = useDispatch();
    // Set by the heartbeat: a reload gives the tab clean state, while "Reconnect now" stays for the
    // beforeunload case where the worker is still alive.
    const isSharedWorkerDead = useSelector(selectIsSharedWorkerDead);

    const handleReconnect = () => {
        console.log('Reconnecting browser window to SharedWorker');
        dispatch(generalActions.setIsWindowDisconnectedFromSharedWorker(false));
        dispatch(generalActions.triggerWindowReconnectionToSharedWorker());
        dispatch(transactionActions.setIsVideoWallEnabled(false));
        dispatch(transactionActions.registerSharedWorker());
    };

    const handleReload = () => {
        console.log('Reloading browser window after SharedWorker stopped responding');
        // The worker is shared, so the other tabs are told too; each one probes the worker before reloading.
        // A unique value is sent because the reload can cut off the signal's cleanup, and re-setting the
        // same value would not fire a storage event next time.
        sendLocalStorageSignal(SHARED_WORKER_DEAD_SIGNAL, Date.now());
        flushLogsThenReload();
    };

    return (
        <AiqBackdrop>
            <Stack spacing={3.5} alignItems="center">
                <FontAwesomeIcon icon={faLinkSlash} size="6x" style={{ color: 'var(--text-secondary)' }} />
                <Stack>
                    <Typography
                        sx={{
                            fontSize: '1.3rem',
                            fontWeight: 'bold',
                        }}
                    >
                        {isSharedWorkerDead ? 'AIQ lost connection to its background service' : 'This browser tab has been disconnected'}
                    </Typography>
                    <Typography align="center">
                        {isSharedWorkerDead ? 'Reload the page to continue.' : 'Close the tab or try to reconnect again.'}
                    </Typography>
                </Stack>

                {isSharedWorkerDead ? (
                    <Button variant="contained" sx={{ textTransform: 'none' }} onClick={handleReload}>
                        Reload page
                    </Button>
                ) : (
                    <Button variant="contained" sx={{ textTransform: 'none' }} onClick={handleReconnect}>
                        Reconnect now
                    </Button>
                )}
            </Stack>
        </AiqBackdrop>
    );
}

export default DisconnectedFromSharedWorker;
